import { useSelector } from 'react-redux';

import type { ScenarioGridRowKey } from '@makemydeal/dr-dash-store/types/scenarioGridTypes';
import { scopedStateSelectors } from '@makemydeal/shared-scoped-store';
import type { ScopedStateProps } from '@makemydeal/shared-scoped-store';

export const useScenarioCellId = (rowKey: ScenarioGridRowKey): string => {
    const scopeId = useSelector<ScopedStateProps, string>(scopedStateSelectors.getCurrentScopeId);
    return `mv-${scopeId}-${rowKey}`;
};
